// Escolher a cor do texto que assenta numa cor de fundo que nao e nossa.
//
// A primaria de um chat e escrita pelo tenant no painel do widget e pode ser
// qualquer coisa: o azul da Radio Popular, mas tambem um amarelo palido. Supor
// branco por cima dela e o erro classico, e num tom claro produz texto que nao
// se le. Estas funcoes decidem pela aritmetica da WCAG 2.1 em vez de pelo
// habito.

// Um hex de 3 ou 6 digitos com cardinal, e mais nada. `theme.primary` pode vir
// a null, pode vir vazio de uma config antiga, e pode vir com um nome de cor
// que o CSS aceitaria mas que aqui nao sabemos medir. Tudo isso e invalido: o
// chamador fica com os tokens da casa em vez de mandar lixo para o CSS.
const HEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export const isHexColor = (value) => typeof value === "string" && HEX.test(value.trim());

// "#abc" -> [170, 187, 204]
const toChannels = (hex) => {
  const raw = hex.trim().slice(1);
  const full = raw.length === 3 ? raw.replace(/./g, (c) => c + c) : raw;
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
};

// WCAG 2.1, "relative luminance": cada canal sai de sRGB para linear e depois
// pesa-se pela sensibilidade do olho, que e sobretudo verde. O ramo dos 0.03928
// existe porque a curva do sRGB e linear ao pe do preto.
const linearize = (channel) => {
  const c = channel / 255;
  return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
};

const relativeLuminance = (hex) => {
  const [r, g, b] = toChannels(hex).map(linearize);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// WCAG 2.1, "contrast ratio": (L do mais claro + 0.05) / (L do mais escuro +
// 0.05). Vai de 1 (iguais) a 21 (preto contra branco). O minimo para texto
// corrido e 4.5.
const contrastRatio = (luminanceA, luminanceB) => {
  const lighter = Math.max(luminanceA, luminanceB);
  const darker = Math.min(luminanceA, luminanceB);
  return (lighter + 0.05) / (darker + 0.05);
};

const WHITE = "#ffffff";
const BLACK = "#000000";
const WHITE_LUMINANCE = 1;
const BLACK_LUMINANCE = 0;

// Preto ou branco por cima de `hex`, o que der mais contraste. Sao literais e
// nao tokens `--color-*` de proposito: a resposta da formula so pode ser um
// destes dois, e um token da casa mudaria com o tema enquanto a primaria do
// tenant nao muda.
//
// Para o #202a8e da Radio Popular: L = 0.0392, branco da 11.77:1 e preto da
// 1.78:1, portanto sai branco com folga sobre o minimo de 4.5.
export const readableForeground = (hex) => {
  const background = relativeLuminance(hex);
  const onWhite = contrastRatio(background, WHITE_LUMINANCE);
  const onBlack = contrastRatio(background, BLACK_LUMINANCE);
  return onWhite >= onBlack ? WHITE : BLACK;
};
